import React from "react";

import { ErrorDetail } from "../../../components/ErrorDetail/ErrorDetail";

export const ErrorIE: React.FC = () => {
  return (
    <>
      <ErrorDetail variant="errorIE" />
    </>
  );
};
